import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiTextInputComponent } from './multi-text-input.component';

@Component({
	selector: 'multi-numeric-text-input',
	templateUrl: 'multi-text-input.html',
	styleUrls: ['multi-text-input.css']
})
export class MultiNumericTextInputComponent extends MultiTextInputComponent {

	@Output() validityChange = new EventEmitter<boolean>();

	constructor() {
		super();
	}
	
	override onFocusOut(focusEvent: any, index: number) {
		super.onFocusOut(focusEvent, index);
		
		// indiquer la validité du champs saisi car on accepte que des nombres
		const isInputValid = /^\d+$/.test(this.textInputs[index].value);
		this.textInputs[index].isValid = isInputValid;
		
		// emettre un signal au conteneur pour dire si existe un champ de saisie invalide
		this.validityChange.emit( this.textInputs.every( input => input.isValid ) );
	}
	
	override removeInput(index: number)	{
		super.removeInput(index);

		// emettre un signal au conteneur pour dire si existe un champ de saisie invalide
		this.validityChange.emit( this.textInputs.every( input => input.isValid ) );
		return false;
	}
	
}